import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text, fontSizeMixin, fontWeightMixin, lineHeightMixin, mediaBreakpointMixin } from '@zillow/constellation';

var StyledContent = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-1edx0wt-0"
})(["text-align:center;display:block;font-size:", ";font-weight:", ";line-height:", ";color:inherit;@media ", "{font-size:", ";line-height:", ";}"], fontSizeMixin('h4'), fontWeightMixin('body'), lineHeightMixin('h4'), mediaBreakpointMixin('sm_lte'), fontSizeMixin('h6'), lineHeightMixin('h6'));
var BlockQuoteContent = function BlockQuoteContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledContent, null, children);
};
BlockQuoteContent.propTypes = process.env.NODE_ENV !== "production" ? {
  // Prefer string, but can pass anything. Non-string is used by editor.
  children: PropTypes.node.isRequired
} : {};
var BlockQuoteContent$1 = BlockQuoteContent;

export { BlockQuoteContent$1 as default };
